import React from 'react';
import InputTextNested from '../Form/InputTextNested';
import PropTypes from 'prop-types';
import { InputContainer } from '../Form/FormElements.styles';
import InfoCard from '../InfoCard/InfoCard.component';
// import { FormBackground } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';

const ManagerEmployeeInput = ({
  user,
  setUser,
  setType,
  type,
  showType,
  title = 'Edit Employee / Manager',
  showPassword = true,
}) => {
  const typeTemplate = (
    <>
      <InputContainer className="formInputUnderline">
        <label htmlFor="type" className="p1R">
          Type
        </label>
        <select
          name="type"
          id="type"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="Manager">Manager</option>
          <option value="User">Employee</option>
          {/* {data?.type === 'Admin' && <option value="User">Regular User</option>} */}
        </select>
      </InputContainer>
      <InfoCard
        paragraph="Manager: Has full access to company account, can
          purchase courses for all employees & managers, view, edit and delete
          employees & managers."
        paragraph2="Employee: Can only view and purchase courses for
          themselves, cannot view, edit or delete other employees & managers."
        adminOnly="Select Employee to make a regular user account with no associated
              company. Can only view and purchase courses for themselves. Then
              delete the company from the user."
      />
    </>
  );
  return (
    <>
      {/* <FormBackground> */}
      <h3>{title}</h3>

      {/* First Name */}
      <InputTextNested
        title="First Name"
        value={user?.firstName}
        name="firstName"
        placeholder="Joe"
        requiredInput={true}
        nestedValue={setUser}
        upperValue={user}
        containerClassName="formInputUnderline"
      />
      {/* Last Name */}
      <InputTextNested
        title="Last Name"
        value={user?.lastName}
        name="lastName"
        requiredInput={true}
        nestedValue={setUser}
        upperValue={user}
        containerClassName="formInputUnderline"
      />
      {/* Email */}
      <InputTextNested
        title="Email"
        value={user?.email}
        name="email"
        requiredInput={true}
        nestedValue={setUser}
        upperValue={user}
        containerClassName="formInputUnderline"
      />
      {/* Phone Number */}
      <InputTextNested
        title="Phone Number"
        value={user?.phoneNumber}
        name="phoneNumber"
        nestedValue={setUser}
        upperValue={user}
        containerClassName="formInputUnderline"
      />
      {showPassword && (
        <InputTextNested
          title="Password"
          value={user?.password}
          name="password"
          requiredInput={true}
          nestedValue={setUser}
          upperValue={user}
          containerClassName="formInputUnderline"
        />
      )}
      {showType && typeTemplate}
      {/* </FormBackground> */}
    </>
  );
};
ManagerEmployeeInput.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    password: PropTypes.string,
  }),
  setUser: PropTypes.func,
  setType: PropTypes.func,
  type: PropTypes.string,
  showType: PropTypes.bool,
  showPassword: PropTypes.bool,
  title: PropTypes.string,
};

export default ManagerEmployeeInput;
